import { render } from "./ContactPanelView.vue?vue&type=template&id=4fe61f08"
import script from "./ContactPanelView.vue?vue&type=script&lang=js"
export * from "./ContactPanelView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__